import { app } from './../../main';

import { MutationTree } from 'vuex';
import { GlobalState } from './types';

export const mutations: MutationTree<GlobalState> = {
    setLangSuccess(state: any, lang: string) {
        state.lang = lang;
        app.$i18n.locale = lang;
    },
};
